/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {AuthPage, AdminPermissionsProvider} from '../modules/auth'
import {App} from '../App'
import Protected from '../../utils/helpers/Protected'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const AppRoutes: FC = () => {
  // const {currentUser} = useAuth()
  // const [user,setUser] = useState(false)
  //
  // useEffect(()=>{
  //   if(!user){
  //     const userInterval = setInterval(()=>{
  //       const admin = () =>{
  //         const currentUser :any= localStorage.getItem("admin")
  //         console.log(currentUser)
  //         if(currentUser) setUser(true);
  //       }
  //       admin()
  //     },1);
  //     return()=>clearInterval(userInterval)
  //   }
  // },[user])

  return (
    <BrowserRouter>
      <AdminPermissionsProvider>
        <Routes>
          <Route element={<App />}>
            {/*  <Route path='error/*' element={<ErrorsPage />} />*/}
            {/*  <Route path='logout' element={<Logout />} />*/}
            {/*{user ? (*/}
            {/*  <>*/}
            {/*    <Route path='/*' element={<PrivateRoutes />} />*/}
            {/*    <Route path='/' element={<Navigate to='/dashboard' />} />*/}
            {/*  </>*/}
            {/*) : (*/}
            {/*  <>*/}
            {/*    <Route path='auth/*' element={<AuthPage />} />*/}

            {/*    <Route path='*' element={<Navigate to='/auth' />} />*/}
            {/*  </>*/}
            {/*)}*/}
            {/*</Route>*/}
            <Route path='auth/*' element={<AuthPage />} />
            <Route element={<Protected />}>
              <Route path='*' element={<PrivateRoutes />} />
              <Route path='/' element={<Navigate to='/dashboard' />} />
            </Route>
          </Route>
        </Routes>
      </AdminPermissionsProvider>
    </BrowserRouter>
  )
}

export {AppRoutes}
